module.exports = __webpack_public_path__ + "img/wagon-covered.3ed1571f.svg";